import { postDataPromise } from 'brock-fetch-utils';

const logPerformanceToConsole = false;
const logPerformanceToLogFile = false;
const goodThresholdMS = 300;
const okThresholdMS = 1000;

/* eslint-disable no-console */
const PerformanceUtils = (() => {
    let logUri = null;
    const stats = {
        short: 0,
        medium: 0,
        long: 0
    };

    function logPerformanceMessage(message) {
        return postDataPromise(logUri, message);
    }

    function getConsoleValueColor(elapsedTime) {
        if (elapsedTime <= goodThresholdMS) {
            return 'green';
        }

        if (elapsedTime <= okThresholdMS) {
            return 'orange';
        }

        return 'red';
    }

    function updateStats(elapsedTime) {
        switch (true) {
            case elapsedTime <= goodThresholdMS: {
                stats.short += 1;
                break;
            }
            case elapsedTime <= okThresholdMS: {
                stats.medium += 1;
                break;
            }
            default:
                stats.long += 1;
                break;
        }
    }

    return {
        setLogUri: uri => {
            logUri = uri;
        },

        markPerformanceStart: markerName => ({
            markerName,
            start: performance.now()
        }),

        getPerformanceMeasure: performanceHandle => {
            const elapsedTime = performance.now() - performanceHandle.start;
            updateStats(elapsedTime);

            if (logPerformanceToConsole) {
                console.log(
                    `%c<Dashboard Performance> %c${performanceHandle.markerName} - %c${elapsedTime}ms`,
                    'color: blue; font-weight: bold',
                    'color: black',
                    `color: ${getConsoleValueColor(elapsedTime)}`
                );
            }

            if (logPerformanceToLogFile) {
                logPerformanceMessage(
                    `<Dashboard Performance> ${performanceHandle.markerName} - ${elapsedTime}ms`
                );
            }

            return elapsedTime;
        },

        logStats: () => {
            if (logPerformanceToConsole) {
                console.log(
                    `%c<Dashboard Performance Stats>
                %cCalls <= ${goodThresholdMS}ms: ${stats.short}\n\
                %cCalls <= ${okThresholdMS}ms: ${stats.medium}\n\
                %cCalls > ${okThresholdMS}ms: ${stats.long}
                `,
                    'color: blue; font-weight: bold',
                    'color: green',
                    'color: orange',
                    'color: red'
                );
            }

            if (logPerformanceToLogFile) {
                logPerformanceMessage(`<Dashboard Performance Stats>\n\
                Calls <= ${goodThresholdMS}ms: ${stats.short}\n\
                Calls <= ${okThresholdMS}ms: ${stats.medium}\n\
                Calls > ${okThresholdMS}ms: ${stats.long}
            `);
            }
        }
    };
})();
/* eslint-enable no-console */

export default PerformanceUtils;
